import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useIsOrganizer = () => {
  return useQuery({
    queryKey: ['is-organizer'],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      
      if (!user) {
        return false;
      }

      const { data, error } = await supabase.rpc('has_role', {
        _user_id: user.id,
        _role: 'event_organizer'
      });

      if (error) {
        console.error('Error checking organizer status:', error);
        return false;
      }

      return data === true;
    },
    staleTime: 300000, // 5 minutes
    refetchInterval: 300000,
  });
};
